function service(state = { result: '', serviceReset: false, lastService: '', serviceInvoice: '', faultsByCustomer:[] }, action) {

  switch (action.type) {

    case "ADD_SERVICE":
      return {
        ...state,
        result: action.data
      };
    case "RESET_SERVICE":
      return {
        ...state,
        serviceReset: action.data
      }
    case "GET_LAST_TASK":
      return {
        ...state,
        lastService: action.data
      }
      case "GET_SERVICE_INVOICE":
        return {
          ...state,
          serviceInvoice: action.data
        }
        case "LOAD_FAULTS_CUSTOMER":
          return{
            ...state,
            faultsByCustomer: action.data
          }

    default:
      return state;
  }
}

export default service;